import { FC } from 'react';
import styles from './InputWithFloatLabel.module.css';
import { InputWithFloatLabelProps } from './InputWithFloatLabel.props';

const InputWithFloatLabel: FC<InputWithFloatLabelProps> = ({id,label,onChange,type='input',value}) => (
  <div className={styles.floating}>
    {type==='textarea'?
      <textarea
        required
        onChange={onChange}
        value={value}
        id={`input__${id}`}
        className={`${styles.floating__input} ${styles.floating__textarea}`}
        placeholder={label} />
      :
      <input
        required
        onChange={onChange}
        type={type}
        value={value}
        id={`input__${id}`}
        className={styles.floating__input} placeholder={label} />
    }

    <label htmlFor={`input__${id}`} className={styles.floating__label} data-content={label}>
      <span className={styles.hiddenVisually}> {label}</span>
    </label>
  </div>
);

export { InputWithFloatLabel };
